import { useFormikContext } from 'formik';

import Notification from '#src/components/Notification';
import Link from '#src/components/Link';

import {
  QuizCartPaymentAndRegistrationForm,
  SubmittingOverlay,
} from '../../../../Cart';
import {
  OfferCountdown,
  MembershipHighlights,
  GoalReinforcement,
} from '../../common/';
import {
  selectPromoOrderItem,
  selectMembershipOrderItem,
} from '../../../helpers';
import { withCheckoutForm } from '../../../withCheckoutForm';
import { getPlanHighlights } from '../../common/helpers';
import paymentStyles from '../../common/paymentForm.module.scss';
import commonStyles from '../../common/styles.module.scss';
import { MembershipDisclaimer } from '../../common/MembershipDisclaimer.js';

import { MembershipItem } from './MembershipItem';
import { Total, TotalFootnote } from './Total';
import localStyles from './styles.module.scss';

const styles = { ...commonStyles, ...localStyles };

/*
 * For the time being, this component may add a game to the order, but will not be shown.
 * This is because any gameId passed to this component will be considered the "homeroom" game,
 * therefore should not be shown to the user.
 */
const Component = ({
  className,
  ctaLabel,
  disabled,
  guaranteeDays,
  isAdHocMembershipOrder,
  order,
  requiresRegistration,
  memberships,
  paidNotification,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  theme,
  token,
  user,
}) => {
  const { isSubmitting } = useFormikContext();

  const membershipOrderItem = selectMembershipOrderItem(order);
  const promoOrderItem = selectPromoOrderItem(order);
  const isOrderFinal = order.status == 'final';
  const planHighlights = getPlanHighlights(promoOrderItem);
  const pressLogos = [
    { key: 1, publicId: 'hub/content/press-logos/today-gray.svg' },
    { key: 2, publicId: 'hub/content/press-logos/people-gray.svg' },
    { key: 3, publicId: 'hub/content/press-logos/abc-news-gray.svg' },
    { key: 4, publicId: 'hub/content/press-logos/wsj-gray.svg' },
    { key: 5, publicId: 'hub/content/press-logos/nyt-times-gray.svg' },
  ];

  const { weight: startWeight, goalWeight } =
    user?.gameProfile?.onboardingInformation || {};

  return (
    <div className={styles.cartContainer}>
      {isSubmitting && <SubmittingOverlay />}

      <Link to="/" className={styles.logoContainer}>
        <img
          src="https://res.cloudinary.com/waybetter-staging/image/upload/v1/hub/content/4KSDHOXqc80o8wAeiCs8sw/549a4d5cdc93265c4db6397fd0e6d758/waybetter_logo_hub.svg"
          className={styles.logo}
        />
      </Link>

      <div className={styles.cardContainer}>
        <div className={styles.twitterBird}>
          <img src="//res.cloudinary.com/waybetter/image/upload/v1694136276/twitter-bird_zsyja6.png" />
        </div>
        <div className="cardContent">
          <GoalReinforcement
            gameProfile={user?.gameProfile}
            className={styles.goalReinforcement}
          />
          <OfferCountdown fromDate={order.updatedAt} user={user} />
          {isOrderFinal && <Notification>{paidNotification}</Notification>}
          <MembershipHighlights
            startWeight={startWeight}
            goalWeight={goalWeight}
            planHighlights={planHighlights}
          />

          <div className={styles.priceContainer}>
            <h3 className={styles.priceHeading}>Price Today</h3>
            <div className={styles.items}>
              {memberships?.map?.(({ id, ...rest }) => (
                <MembershipItem key={id} {...rest} />
              ))}
            </div>
            <Total
              subscription={
                membershipOrderItem.selectedPaymentPlan?.subscription
              }
            />
            <TotalFootnote
              subscription={
                membershipOrderItem.selectedPaymentPlan?.subscription
              }
            />

            {!isOrderFinal && (
              <QuizCartPaymentAndRegistrationForm
                ctaLabel={ctaLabel}
                ctaDisabled={disabled}
                guaranteeDays={guaranteeDays}
                isAdHocMembershipOrder={isAdHocMembershipOrder}
                order={order}
                requiresRegistration={requiresRegistration}
                savePaymentLabel={savePaymentLabel}
                setBraintreeInstance={setBraintreeInstance}
                setPaymentMethodReady={setPaymentMethodReady}
                parentStyles={paymentStyles}
                pressLogos={pressLogos}
                theme={theme}
                token={token}
              />
            )}

            <MembershipDisclaimer
              membershipOrderItem={membershipOrderItem}
              theme={theme}
            />

            <div className={styles.footer}>
              <p className={styles.copy}>© 2010-2021 WayBetter, Inc.</p>
              <p className={styles.terms}>Terms of Use • Privacy Policy</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const QuizCart = withCheckoutForm(Component);
